export {default} from './cards.vue'
export {default as SaveDoc} from './save-doc.vue'